import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { DebitorModel } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class DebitorService extends RestServiceBase<DebitorModel> {
    constructor(
    ) {
        super("DebitorModel", false);
    }
}